import React, { useState } from "react";

import { useMsal } from "@azure/msal-react";

import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  TextField,
  Grid,
  Switch,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import DbUpload from "./FileUpload";
import apiCall from "../utils/apiCall";
import getBase64 from "../utils/getBase64";
import validateFileName from "../utils/validateFileName";

import { DATABASE, EXCEL, IMAGE, NEO4J, PDF, YOUTUBE } from "../data/constants";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";
import { addFiles, getFiles, getType } from "../redux/slices/typeSlice";
import { loadingforindexes } from "../redux/slices/loadingSlice";
import { addError } from "../redux/slices/errorSlice";
import ConfirmModal from "./ConfirmModal";
import Neo4jConnectionAdd from "./Neo4jConnectionAdd";
import { CREATE_INDEX_IMG_DOC } from "../endpoint";
import { getModelDetails } from "../redux/slices/modelSlice";
import hyperscaler_mapping from "../data/modelMapping";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface i_value {
  base64: string;
  name: string;
  filetype: string;
  size?: number;
}

interface IChatDbUpload {
  open: boolean;
  setOpen: any;
}

const UploadFile = ({ open, setOpen }: IChatDbUpload) => {
  const { accounts } = useMsal();
  const accountId = accounts[0]?.username;

  const models = useAppSelector(getModelDetails);

  const [value, setValue] = useState<i_value | null>();
  const [name, setName] = useState("");
  const [sqlconfig, setSqlconfig] = useState<any>();
  const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
  const [confirmReplace, setConfirmReplace] = useState("");
  const [connectionString, setConnectionString] = useState("");
  const [unprocessable, setUnprocessable] = useState(false);
  const [imageModel, setimageModel] = useState(
    models?.models?.multimodal?.at(0)?.model_name
  );

  const selectImageModel = (e: any) => {
    setimageModel(e.target.value);
  };

  const chatType = useAppSelector(getType);
  const files = useAppSelector(getFiles);

  const dispatch = useAppDispatch();

  const handleClose = () => {
    setOpen(false);
    setValue(null);
    setName("");
    setUnprocessable(false);
  };

  const uploadDb = (confirm: any) => {
    setOpen(false);
    if (chatType.type === PDF) {
      const regex = /^[a-zA-Z0-9][a-zA-Z0-9_]*$/;
      // if (dbType === "pdf") {
      if (name === "") {
        dispatch(addError("Please add a Index name"));
        return;
      } else if (!regex.test(name)) {
        dispatch(
          addError(
            "Index name must use only letters, numbers, or underscores, start with a letter or number, uppercase and lowercase both allowed"
          )
        );
        return;
      } else if (
        files?.includes(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        ) &&
        confirm !== true
      ) {
        setOpenConfirmModal(true);
        setConfirmReplace(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        );
      } else {
        //   dispatch(startLoading())
        dispatch(loadingforindexes(true));
        apiCall(
          "POST",
          unprocessable ? CREATE_INDEX_IMG_DOC : chatType.loadurl,
          {
            pdf: value?.base64,
            chunk_name:
              name.replace(" ", "_") +
              "---" +
              accountId +
              "---" +
              value?.filetype,
            file_type: value?.filetype,
            user_email: accountId,
            model: imageModel,
            machinereadable: unprocessable,
          }
        )
          .then((res) => {
            dispatch(addFiles(res.result));
            handleClose();
          })
          .catch((err) => {
            console.log(err);
            dispatch(addError("Something went wrong!!"));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
          });
      }
    } else if (chatType.type === IMAGE) {
      if (
        files?.includes(value?.name.split(".")[0] + "---" + value?.filetype) &&
        confirm !== true
      ) {
        setOpenConfirmModal(true);
        setConfirmReplace(value?.name.split(".")[0] + "---" + value?.filetype);
      } else {
        dispatch(loadingforindexes(true));
        apiCall("POST", chatType.loadurl, {
          image: {
            base64_string: value?.base64,
            filename: name + "---" + value?.filetype,
          },
          user_email: accountId,
        })
          .then((res) => {
            dispatch(addFiles(res.result));
            handleClose();
          })
          .catch((err) => {
            dispatch(addError("Something went wrong while uploading image"));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
          });
      }
    } else if (chatType.type === EXCEL) {
      if (
        files?.includes(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        ) &&
        confirm !== true
      ) {
        setOpenConfirmModal(true);
        setConfirmReplace(
          name.replace(" ", "_") + "---" + accountId + "---" + value?.filetype
        );
      } else {
        apiCall("POST", chatType.loadurl, {
          excel: value?.base64,
          file_name: name.replace(" ", "_") + "---" + accountId,
          user_email: accountId,
        })
          .then((res) => {
            dispatch(addFiles(res.result));
            handleClose();
          })
          .catch((err) => {
            dispatch(addError("Something went wrong while uploading image"));
          })
          .finally(() => {
            dispatch(loadingforindexes(false));
          });
      }
    } else if (chatType.type === DATABASE) {
      apiCall("POST", chatType.loadurl, {
        connection_string: connectionString,
        name: name,
        user_email: accountId,
      })
        .then((res) => {
          dispatch(addFiles(res.result));
          handleClose();
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while uploading image"));
        })
        .finally(() => {
          dispatch(loadingforindexes(false));
        });
    } else if (chatType.type === YOUTUBE) {
      apiCall("POST", chatType.loadurl, {
        url: connectionString,
        video_name: name + "---" + accountId + "---yt",
        user_email: accountId,
      })
        .then((res) => {
          dispatch(addFiles(res.result));
          handleClose();
        })
        .catch((err) => {
          dispatch(addError("Something went wrong while uploading image"));
        })
        .finally(() => {
          dispatch(loadingforindexes(false));
        });
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogContent sx={{ p: 4 }}>
        {chatType.type === DATABASE || chatType.type === YOUTUBE ? (
          <>
            <TextField
              value={connectionString}
              onChange={(e) => setConnectionString(e.target.value)}
              label={
                chatType.type === DATABASE
                  ? "Enter Connection String"
                  : "Enter URL"
              }
              variant="outlined"
              // sx={{ mt: 2 }}
              fullWidth
              sx={{
                mt: 2,
                ".MuiFormHelperText-root": {
                  color: "rgba(255,0,0,0.5)",
                  fontSize: "11px",
                },
              }}
            />
            <TextField
              value={name}
              onChange={(e) => setName(e.target.value)}
              label={chatType.type === DATABASE ? "DB Name" : "Name"}
              variant="outlined"
              // sx={{ mt: 2 }}
              fullWidth
              sx={{
                mt: 2,
                ".MuiFormHelperText-root": {
                  color: "rgba(255,0,0,0.5)",
                  fontSize: "11px",
                },
              }}
            />
            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 4 }}
              disabled={!name || !connectionString}
              onClick={uploadDb}
              color="secondary"
            >
              {chatType.type === DATABASE ? "Add Database" : "Add Video"}
            </Button>
          </>
        ) : chatType.type === NEO4J ? (
          <Neo4jConnectionAdd
            url={chatType?.loadurl}
            handleClose={handleClose}
          />
        ) : (
          <>
            <DbUpload
              content="Drag and drop a file"
              setFile={(file: FileList) => {
                if (chatType.type === DATABASE) setSqlconfig(file);
                const validation = validateFileName(file[0], chatType?.uploadtypes || []);
                if (!validation.isValid) {
                  dispatch(addError(validation.message));
                  return;
                }
               getBase64(file[0]).then((res) => {

                const fileSize = file[0].size;
                const fileSizeInMB = fileSize / (1024 * 1024); // Convert to MB
                
                if (fileSizeInMB >= 4) {
                  dispatch(addError("File size exceeds the 4MB limit"))
                  return;
                }
                
                setValue({
                  base64: res.split(",")[1].toString(),
                  filetype: validation.extension,
                  name: validation.safeFileName,
                });
                setName(validation.safeFileName);
              });

              }}
              file={value}
            />
            <Grid container justifyContent="center">
              <TextField
                value={name}
                onChange={(e) => setName(e.target.value)}
                label={
                  chatType.type === PDF
                    ? "Enter Index Name"
                    : chatType.type === IMAGE
                      ? "Name"
                      : "DB Name"
                }
                variant="outlined"
                // sx={{ mt: 2 }}
                fullWidth
                helperText={
                  chatType.type === PDF ? (
                    "Index name must use only letters, numbers, or underscores, start with a letter or number, uppercase and lowercase both allowed.   Example: reports_2025_SalesData"
                  ) : chatType.type === EXCEL ? (
                    <>
                      Only Microsoft Excel files with the .xlsx extension can be
                      uploaded.
                      <br /> The maximum file size allowed is 5 MB.
                      <br /> Files should not contain more than 5 worksheets.
                      <br /> The application does not support merged cells,
                      formulas, or macros in Excel files.
                    </>
                  ) : (
                    ""
                  )
                }
                sx={{
                  mt: 2,
                  ".MuiFormHelperText-root": {
                    color: "rgba(255,0,0,0.5)",
                    fontSize: "11px",
                  },
                }}
              />
            </Grid>
            {chatType.type === PDF && (
              <Grid
                container
                direction="column"
                sx={{
                  borderTop: "1px solid rgba(0,0,0,0.1)",
                  mt: 2,
                }}
              >
                <Grid container alignItems="center">
                  <Switch
                    defaultChecked
                    color="secondary"
                    onChange={(e) => setUnprocessable(e.target.checked)}
                    checked={unprocessable}
                  />
                  <Typography
                    fontSize="small"
                    color="secondary"
                    sx={{
                      flex: 1,
                    }}
                  >
                    Need support for image read.
                  </Typography>
                </Grid>
                {unprocessable && (
                  <Grid>
                    <Typography
                      fontSize="small"
                      sx={{
                        mt: 2,
                      }}
                    >
                      Select an image model to process
                    </Typography>
                    <Select
                      value={imageModel}
                      onChange={selectImageModel}
                      size="small"
                      sx={{
                        width: "100%",
                        fontSize: "11px",
                        border: "1px solid #CBCBCB",
                        backgroundColor: "#F3F3F3",
                        textTransform: "capitalize",
                        borderRadius: "0px",
                        "& .MuiSelect-outlined": {
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "row",
                        },
                        "& .MuiPaper-rounded": {
                          borderRadius: "0px",
                        },
                      }}
                    >
                      {models?.models?.multimodal?.map((model, i) => (
                        <MenuItem
                          key={i}
                          value={model?.model_name}
                          sx={{
                            "&.Mui-selected": {
                              backgroundColor: "#FFD2B9",
                            },
                            textTransform: "capitalize",
                          }}
                        >
                          <img
                            src={
                              hyperscaler_mapping[
                              `${model?.model?.split("/")[0] ?? "psl"}`
                              ]
                            }
                            alt={`${model.model_name}`}
                            width="15px"
                          />{" "}
                          &nbsp;
                          {model?.model_name
                            .replaceAll(
                              process.env?.REACT_APP_DEFAULT_MODEL_REMOVE ?? "",
                              ""
                            )
                            .replaceAll("-", " ")}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                )}
              </Grid>
            )}
            <Button
              variant="contained"
              fullWidth
              sx={{ mt: 4 }}
              disabled={
                !value?.base64 ||
                (!name && [PDF, DATABASE].includes(chatType.type))
              }
              onClick={uploadDb}
              color="secondary"
            >
              Upload File
            </Button>
          </>
        )}
      </DialogContent>
      <ConfirmModal
        open={openConfirmModal}
        setOpen={() => {
          setOpenConfirmModal(false);
          setOpen(true);
        }}
        onclick={() => {
          setOpenConfirmModal(false);
          apiCall("POST", chatType.deleteurl, {
            chunk_name: confirmReplace,
            image_name: confirmReplace,
            user_email: accountId,
          })
            .then((res) => {
              uploadDb(true);
            })
            .catch((err) => {
              dispatch(addError("Something went wrong"));
            });
        }}
      />
    </Dialog>
  );
};

export default UploadFile;